import ReactStrapTable from "components/reactStrapTable";
import React, { useState } from "react";
import {
  Container,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import { Field, Formik } from "formik";
import ArrowRight from "assets/icon/arrow-right-purple.svg";
import plusIcon from "assets/icon/plus-rx.svg";
import { useNavigate } from "react-router-dom";
import SearchContainer from "pages/OrderEntry/SearchContainer/Index";
import leftArrow from "assets/icon/left-arrow.svg";
import ReactInputMask from "react-input-mask";
import Calendar from "assets/icon/calendar-pms.svg";
import admin from "assets/icon/admin-black.svg";
import patientDate from "assets/icon/paitent-date.svg";
import changePatientIcon from "assets/icon/change-patient-icon.svg";
import DatePicker from "react-datepicker";
import moment from "moment";


const CreateNewRx = () => {
  const [focusedInput, setFocusedInput] = useState("");
  const [error, setError] = useState(false);
  const [isSubmited, serIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartdate] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [showText, setShowText]= useState("Search for a Patient to add New Rx")

  const navigate = useNavigate();

  const goback = () => {
    navigate(-1);
  };
  const handleClick = () => {
    navigate("/workflow-orderEntry-addNewRxSearch");
  };
  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleBlur = () => {
    setFocusedInput("");
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };
  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const addInputBoxHandler = () => {
    if (inputValue.trim().toLowerCase() === "john doe") {
      navigate("/workflow-orderEntry-addNewPatient");
    } else if (inputValue.trim() === "") {
      setError("Input cannot be empty!");
    }

    // else if (startDate && inputValue ===  "01/08/1996") {
    //   console.log('Searching for patient with birthdate 01/08/1996...');

    // }
    else if (inputValue.trim().toLowerCase() !== "john doe") {
      setShowText("Above data not found")
    }
  };

  return (
    <div className="bg-white p-3">
      <Container
        fluid
        className="d-flex gap-2 orderEntry-heading section-devider-border pb-2 mb-1 mb-8 pb-16"
      >
        <img className="cursor-pointer left-arrow-btn" src={leftArrow} onClick={goback} />
        <div className="heading-text ">Create New Rx</div>
      </Container>
      <Container fluid className="pt-16">
        {/* <SearchContainer/> */}
        <Row>
          <Col sm={12} md={5}>
            <FormGroup className="controls mb-0">
              <InputGroup className="order-entry-search">
                <img src={admin} className="search-patient-input" />
                <Input
                  id="reportname"
                  name="reportname"
                  type="text"
                  placeholder="Search by Patient Name"
                  autoComplete="off"
                  className="input-spacing-left"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </InputGroup>
            </FormGroup>
            <Label className="f-12 ml-10">
              {" "}
              {error && <p className="text-danger">{error}</p>}
            </Label>
          </Col>
          <Col sm={12} md={5} className="required-date1 mb-2">
            <InputGroup
              onMouseLeave={handleMouseLeave}
              className="remove-outline  order-entry-search "
            >
              <img src={patientDate} className="img-patient" />
              <DatePicker
                id="startDate"
                name="startDate"
                selected={startDate}
                onChange={(startDate) => handleStartDate(startDate)}
                onFocus={() => handleFocus("StartDate")}
                onBlur={handleBlur}
                isClearable
                onChangeRaw={handleStartDateRaw}
                dateFormat="MM/dd/yyyy"
                placeholderText="MM/DD/YYYY"
                autoComplete="off"
                className="input-spacing-left"
                customInput={
                  <ReactInputMask mask="99/99/9999" value={startDate} />
                }
              />
              <InputGroupText
                className="date-img"
                onClick={() => handleDateClick("startDate")}
              >
                <img src={Calendar} className="cursor-pointer" alt="" />
              </InputGroupText>
            </InputGroup>
          </Col>
          <Col
            sm={12}
            md={2}
            className="mb-2"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <Button
              color="primary"
              className="search"
              disabled={!inputValue}
              onClick={addInputBoxHandler}
            >
              Search
            </Button>
          </Col>
        </Row>
      </Container>

      <Container fluid>
        <Row>
          <Formik
            // initialValues={searchTerms}
            // onSubmit={handleSubmit}
            // onReset={handleReset}
            // validationSchema={validationSchema}
            // enableReinitialize={true}
            children={(props) => {
              const {
                isSubmitting,
                handleSubmit,
                resetForm,
                setFieldValue,
                errors,
                touched,
              } = props;
              return (
                <div>
                  <Container className="Rx-table ">
                    <Row >
                      <Col>{showText }</Col>
                    </Row>
                    <Row>
                      <Col className="mt-1 mb-1" style={{color:"#9E9E9E"}}>Or</Col>
                    </Row>
                    <Row>
                      <Col>
                        <button
                          className="primary btn btn-dark d-flex align-items-center justify-content-between"
                          onClick={handleClick}
                          style={{ gap: "8px" }}
                        >
                          <img src={plusIcon} alt="Icon" />
                          Add Patient & Create New Rx{" "}
                        </button>
                      </Col>
                    </Row>
                  </Container>
                </div>
              );
            }}
          ></Formik>
        </Row>
      </Container>
    </div>
  );
};

export default CreateNewRx;
